import { privateDecrypt } from "crypto";

declare const bootstrap: any
interface Treatment {
    Label: string;
    Value: string;
}
namespace app {
    interface CustomisedService {
        init?: () => Promise<void>;
        PostSubmit?: (data?: Record<string, string>) => Promise<void>;
        PreSubmit?: (data?: any) => boolean | void;
        PostStepHandlers?: { Step: number, Handler: (data: Record<string, string>) => void }[];
        FormInit?: () => Promise<void>;
        StepInit?: (step: Number) => void;
    }

    //service customisations (PER SERVICE)
    export const CustomServiceLogic: Record<string, CustomisedService> = {
        PatientEnrolment: {
            async init() {
                cp.event.subscribe("app:ready", async (o: any, t: any) => {
                    // reset form
                    const form = document.getElementsByName("PatientEnrolment")[0] as HTMLFormElement;
                    form.reset();
                });
            },
            async FormInit() {
                const radios = document.querySelectorAll<HTMLInputElement>(
                    'input[type="radio"][name="AstellasTreatment"]'
                  );
                  
                const modalElement = document.getElementById('not-found-product');
                
                if (modalElement) {
                    const modal = new (window as any).bootstrap.Modal(modalElement);
                    radios.forEach((radio) => {
                        radio.addEventListener('change', () => {
                      
                          if (radio.checked && radio.value === 'Unknown/Not Listed') {
                            modal.show();
                            // close btn click should close not-found-product popup
                            document.querySelectorAll<HTMLButtonElement>("#not-found-product button.btn.btn-primary")[0].addEventListener("click", () => {
                                modal.hide()
                                const radioToSelect = document.querySelector<HTMLInputElement>('input[name="AstellasTreatment"][value="Xtandi (enzalutamide)"]');
                                if(radioToSelect)
                                    radioToSelect.checked = true;
                            });
                          }
                      
                        });
                      });
                
                }
            },
            async PostSubmit(data: any) {
                // after success message
                cp.ui.loader("hide");

                // success popup redirect
                document.querySelector<HTMLButtonElement>(".axsvc-success .btn-default")?.  addEventListener("click", () => cp.ui.navigate("/en"));
            },
            StepInit(step) {
                const stepIndicatorElem = document.querySelector(".stepped-form__indicators");

                switch (step) {
                    case 1:
                        const btn = document.querySelector(".stepped-form__control--next") as HTMLElement | null;
                        if(btn) {
                         btn.textContent = "Getting Started";
                         btn.classList.add("btn-primary");
                         btn.classList.add("mt-3");
                        }
                       break;
                    case 2:
                        const btn2 = document.querySelector(".stepped-form__control--next") as HTMLElement | null;
                        if(btn2) {
                            btn2.textContent = "Continue";
                            btn2.classList.add("d-none");
                        }
                        // hide prev button on step 2
                        const prevBtn2 = document.querySelector(".stepped-form__control--prev") as HTMLElement | null;
                        prevBtn2?.classList.add("d-none");
                        
                        // hide treatment fields until barcode is valid
                        hideElements(["AstellasTreatment","TimeOnTreatment"]);

                        
                        // add keyup on barcode field to check
                        const barcodeElement = document.querySelector('input[name="Barcode"]') as HTMLInputElement | null;
                        if(barcodeElement) {
                        barcodeElement.addEventListener('keyup', async () => {
                            const barcode = barcodeElement.value;
                            if(barcode.length>=4) {
                                const treatment = await validateBarcode(barcode);
                                if (treatment.Value === "Invalid") {
                                cp.ui.showModal("InvalidBarcode", "<h2>Invalid Barcode</h2><p>The barcode that you entered is not valid. Please check and try again.</p>",
                                    { title: "", buttons: [{ label: "Back", class: "btn btn-primary", action: function () { cp.ui.closeModal("InvalidBarcode"); } }] });
                                } else {
                                // display treatment fields & submit button
                                showElements(["AstellasTreatment","TimeOnTreatment"]);
                                if(btn2) {
                                    btn2.classList.remove("d-none");
                                }
                                }
                            }
                        });
                    }
                        
                      break;
                    case 3:
                        
                    default:
                      // Code to run if no cases match
                  }
            }
        },
        PatientAssessment: {
            StepInit(step) {
                const stepIndicatorElem = document.querySelector(".stepped-form__indicators");
                stepIndicatorElem?.classList.add("d-none");
                switch (step) {
                    case 1:
                       break;
                    case 2:
                        const btn2 = document.querySelector(".stepped-form__control--prev") as HTMLElement | null;
                        if(btn2) {
                            btn2.classList.add("d-none");
                        }
                    default:
                  }
            }
        },
        ProgramFeedback: {
            async init() {
                cp.event.subscribe("app:ready", async (o: any, t: any) => {
                    // reset form
                    const form = document.getElementsByName("ProgramFeedback")[0] as HTMLFormElement;
                    form.reset();

                    document.querySelector(".cp-service__submit")?.addEventListener("click",async function(e) {
                        e.preventDefault();
                        e.stopPropagation();
                        cp.ui.loader("show");
                        const data = new FormData(form);
                        const uploadData = {
                            "satisfactionProgramSupport": data.get("SatisfactionProgramSupport"),
                            "satisfactionQuestionComfort": data.get("SatisfactionQuestionComfort"),
                            "influenceProgram": data.getAll("InfluenceProgram"),
                            "overallMainBenefit": data.get("OverallMainBenefit"),
                        };                
                        
                        fetch("https://api-uat.hec.dev/forms?code=astellas", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify(uploadData)
                        }).then((response) => {
                            cp.ui.loader("hide");
                            return response.json();
                        }).then((result) => {
                            cp.services.list.programfeedback.sucess();
                        }).catch((error) => {
                            throw new Error(`Upload failed: ${error}`);
                        });
                    })
                });
            },
            PreSubmit(data: any) {                
                return false;
            },
        }
    }

    // all methods subscribed immediately
    cp.event.subscribe("service:show", (serviceName: any, d: any) => {
        //if we have customisations for this service then run them
        Object.keys(CustomServiceLogic).forEach((key) => {
            if (key.toLowerCase() == serviceName && CustomServiceLogic[key].init) {
                CustomServiceLogic[key].init?.();
            }
        });
    });

    cp.event.subscribe("service:submit", (serviceName: any, data: any) => {
        //if we have SUBMIT customisations for this service then run them
        if (CustomServiceLogic[serviceName] && CustomServiceLogic[serviceName].PreSubmit)
            CustomServiceLogic[serviceName].PreSubmit?.(data);
    });
    cp.event.subscribe("service:success", (serviceName: any, data: any) => {
        //if we have SUBMIT customisations for this service then run them
        if (CustomServiceLogic[serviceName] && CustomServiceLogic[serviceName].PostSubmit)
            CustomServiceLogic[serviceName].PostSubmit?.(data);
    });

    cp.event.subscribe("form:load", (serviceName: any, data: any) => {
        Object.keys(CustomServiceLogic).forEach((key) => {
            if (key.toLowerCase() == serviceName && CustomServiceLogic[key].FormInit) {
                CustomServiceLogic[key].FormInit?.();
            }
        });
    });

    cp.event.subscribe("app:ready", (serviceName: any, data: string) => {
        if (PageCustomisations[data]) PageCustomisations[data]();
    });

    interface EventData {
        step: Number;
    }
    cp.event.subscribe("service:stepChanged", (serviceName: any, data: EventData) => {
        if(CustomServiceLogic[serviceName].StepInit && data?.step)
        CustomServiceLogic[serviceName].StepInit?.(data.step);
    });

    cp.event.subscribe("login:success", (serviceName: any, data: any) => {
    });

    
}
const PageCustomisations: Record<string, () => Promise<void>> = {
    //ccustomisations per page type
    StartPage: async () => {},
    HomePage: async () => {},
    PublicPage: async () => {
        // Remove home page navigation link from Patient pages
        if(window.location.pathname.includes("/patient/")) {
            const homeLink = document.getElementById("home-link");
            homeLink?.remove();
        }
    }

}

export async function validateBarcode(barcode: string): Promise<Treatment> {
    const barcodeInt = parseInt(barcode);

    if (isNaN(barcodeInt)) {
        return { Label: "Invalid", Value: "Invalid" };
    }

    const res = await fetch("/app/validateBarcode?barcode=" + barcode).then(async function (r) {
        const result: Treatment = await r.json();
        if (result) {
            return result;
        }
        else {
            return { Label: "Invalid", Value: "Invalid" };
        }
    });

    return res as Treatment;
}

function hideElements(array: string[]): void {
    array.forEach((name) => {
        const element = document.querySelector<HTMLElement>(`[name="${name}"]`);

        if (element) {
            element.closest('.form-row')?.classList.add("d-none");
        }
    });
}

function showElements(selectors: string[]): void {
    selectors.forEach(selector => {
      const element = document.querySelector<HTMLElement>(`[name="${selector}"]`);
      if (element) {
        element.closest('.form-row')?.classList.remove("d-none");
      }
    });
}